// **  Initial State
const initialState = {
	data: {},
	loading: false
}

export const settingsReducer = (state = initialState, action) => {
	switch (action.type) {
		default:
			return state
	}
}
